import { Link } from 'react-router-dom'
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter, Linkedin, Heart } from 'lucide-react'
import './Footer.css'

function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <span className="logo-icon">R</span>
              <div className="logo-text">
                <span className="logo-title">RadianTech</span>
                <span className="logo-subtitle">FITNESS</span>
              </div>
            </Link>
            <p className="footer-description">
              Transform your body and mind with premium fitness training. 
              Expert guidance, personalized programs, and a supportive community.
            </p>
            <div className="social-links">
              <a href="https://facebook.com" aria-label="Facebook" className="social-link">
                <Facebook size={20} />
              </a>
              <a href="https://instagram.com" aria-label="Instagram" className="social-link">
                <Instagram size={20} />
              </a>
              <a href="https://twitter.com" aria-label="Twitter" className="social-link">
                <Twitter size={20} />
              </a>
              <a href="https://linkedin.com" aria-label="LinkedIn" className="social-link">
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/schedule">Schedule</Link></li>
              <li><Link to="/trainers">Our Trainers</Link></li>
              <li><Link to="/book">Book a Session</Link></li>
              <li><Link to="/account">My Account</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Premium</h4>
            <ul>
              <li><Link to="/videos">Video Library</Link></li>
              <li><Link to="/live">Live Classes</Link></li>
              <li><Link to="/nutrition">Nutrition</Link></li>
              <li><Link to="/community">Community</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Services</h4>
            <ul>
              <li><Link to="/services">Group Classes</Link></li>
              <li><Link to="/services">Personal Training</Link></li>
              <li><Link to="/services">Semi-Private Training</Link></li>
              <li><Link to="/services">Virtual Training</Link></li>
              <li><Link to="/nutrition">Nutrition</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact Info</h4>
            <div className="contact-info">
              <div className="contact-item-footer">
                <MapPin size={18} />
                <span>123 Fitness Avenue<br />Los Angeles, CA 90001</span>
              </div>
              <div className="contact-item-footer">
                <Phone size={18} />
                <span>(555) 747-7325</span>
              </div>
              <div className="contact-item-footer">
                <Mail size={18} />
                <span>info@radiantech.fitness</span>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} RadianTech Fitness. All rights reserved.</p>
          <p className="made-with">
            Made with <Heart size={14} className="heart-icon" /> for your fitness journey
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
